import { useQuery, useQueries } from '@tanstack/react-query'
import { api } from '@/services/api'

export function useCalendarMonth(year: number, month: number) {
  return useQuery({
    queryKey: ['calendar-month', year, month],
    queryFn: () =>
      api.get(`/api/v1/calendar/month?year=${year}&month=${month}`),
    staleTime: 5 * 60 * 1000,
  })
}

export function useTeacherCalendarMonths(months: { year: number; month: number }[]) {
  return useQueries({
    queries: months.map(({ year, month }) => ({
      queryKey: ['teacher-calendar-month', year, month],
      queryFn: () =>
        api.get(`/api/v1/teacher/timetable/month?year=${year}&month=${month}`),
      staleTime: 5 * 60 * 1000,
    })),
  })
}

export function mergeMonthDays<T extends { date: string; lessons?: unknown[] }>(
  months: Array<{ days?: T[] } | null | undefined>,
): T[] {
  const byDate = new Map<string, T>()
  for (const month of months) {
    for (const day of month?.days ?? []) byDate.set(day.date, day)
  }
  return [...byDate.values()]
}

export function useTeacherAvailability(date: string, entryIds?: string[]) {
  return useQuery({
    queryKey: ['teacher-availability', date, entryIds],
    queryFn: () => {
      const qs = new URLSearchParams({ date })
      if (entryIds?.length) qs.set('entry_ids', entryIds.join(','))
      return api.get(`/api/v1/teacher-requests/availability?${qs.toString()}`)
    },
    enabled: !!date,
    staleTime: 30 * 1000,
  })
}
